/**
 * Звук ошибки на экране набора.
 *
 * Передаётся контекстом по той же причине, что и фокус-режим: экран набора
 * вложен в семь экранов режимов, и ни один из них к настройке звука
 * отношения не имеет.
 */

import { createContext, useContext } from 'react';

/** Подавать ли звук на промах. По умолчанию да: молчащая ошибка не замечается. */
export const SoundOnErrorContext = createContext(true);

/** Включён ли звук ошибки на этом экране. */
export function useSoundOnError(): boolean {
  return useContext(SoundOnErrorContext);
}
